import React, { Component, createContext, useEffect, useState } from "react";

export const MemoryLevelContext = createContext();

const MemoryLevelContextProvider = (props) => {

    const { umbracoValues } = props;

    //* ================================ Toggle time ================================
    const [displayTimer, setDisplayTimer] = useState(false);

    //* ================================= Initial state of levels =================================
    const [levels, setLevels] = useState({
        level: {
            level: null,
            levelName: "",
            levelIsSet: false
        },
        stage: {
            stage: null,
            stageName: "",
            stageIsSet: false
        }
    });
    const [readyToCheckCards, setReadyToCheckCards] = useState(false); //Variable to prevent all cards match if retrieving new array of cards

    //* ================================= Choose levels =================================
    const chooseLevel = ( levelChoise, levelName, levelIsSet) => {
        setLevels({...levels,
            level: {
                level: levelChoise,
                levelName: levelName,
                levelIsSet: levelIsSet
            }        
        });
    }
    
    const chooseStage = ( stageChoice, stageName, stageIsSet) => {
        setLevels({...levels,
                stage: {
                    stage: stageChoice,
                    stageName: stageName,
                    stageIsSet: stageIsSet
                }        
            }); 
    }

    const chooseBoth = (levelChoise, levelName, levelIsSet, stageChoice, stageName, stageIsSet) => {
        setLevels({...levels,
            level: {
                level: levelChoise,
                levelName: levelName,
                levelIsSet: levelIsSet
            },   
            stage: {
                stage: stageChoice,
                stageName: stageName,
                stageIsSet: stageIsSet
            }        
        }); 
    };

    //* ================================= Reset levels =================================
    const unsetLevels = () => {
        setLevels({...levels,
                    level: {level: 0, levelName: "", levelIsSet: false},
                    stage: {stage: 0, stageName: "", stageIsSet: false}
                });
    };

    //* ================================= Get Cards =================================
    const [memoryCards, setMemoryCards] = useState([]);
    const [cardsReady, setCardsReady] = useState(false);
    const getCards = async () => {
        await fetch(`/umbraco/api/memoryapi/getcards?title=${umbracoValues.id}&stageId=${levels.stage.stage}&levelId=${levels.level.level}`)
        .then((response) => response.json())
        .then((response) => {
            setMemoryCards(response);
            setReadyToCheckCards(true);            
            setCardsReady(true);
        })
        .catch(() => console.log("error"));
    }; 


    useEffect(() => {
        if(levels.stage.stageIsSet && levels.level.levelIsSet){ //check if stage and level is set
            getCards();
        }else{
            setCardsReady(false); // if cards not ready
        }
    }, [levels]);

    useEffect(() => {
        if(cardsReady){
            handleShuffleCards();
        }
    }, [cardsReady])
    
    //* ================================= Get all levels =================================
    const [levelList, setLevelList] = useState([]);
    const getAllLevels = async () => {
        await fetch(`/umbraco/api/memoryapi/getlevels?title=${umbracoValues.id}`)
            .then((response) => response.json())
            .then((response) =>  setLevelList(response)) //set aray of all stages & sublevels
            .catch(() => console.log("error"));
    };

    useEffect(() => {
        getAllLevels();
    }, []);







    //* ============================== Things from MemoryGameContext ===============================
   
    const [cards, setCards] = useState([]);
    const [allCardsMatch, setAllCardsMatch] = useState(false);
    const [memoryCompleted, setMemoryCompleted] = useState(false);


    // function to check if first card pick match with second card pick 
    const handleCards = (choiceOne) => {
        setCards(prevCards => {
            return prevCards.map(card => {
                if(card.cardId === choiceOne.cardId){
                    return{...card, matched: true}; 
                } else{
                    return card;
                }
            })
        });
    };

    //*======= Cards do not match =========
    const noMatch = (choices) => {
        choices.map(choice => {
            Object.assign(choice, {noMatch: true});
        })

        setTimeout(() => {
            choices.map(choice => {
                delete choice.noMatch;
            })
        }, 400);
    };

    //set memory completed, occurs when every card has matched: true
    const handleMemoryCompleted = (completed) => {
        setMemoryCompleted(completed);
    };

    const allMatch = cards.every(({matched}) => matched);
    useEffect(() => {
        if(allMatch && readyToCheckCards){
            setAllCardsMatch(true);
        } else{
            setAllCardsMatch(false);
        }
    }, [allMatch]);

    const handleShuffleCards = () => {
        const shuffledMemoryCards = [...memoryCards]
        .sort(() => Math.random() - 0.5)
        .map((card) => ({...card}));

        setCards(shuffledMemoryCards);
        setAllCardsMatch(false);
    };

    //*Get height of wrapper
    const [wrapperHeight, setWrapperHeight] = useState();
    useEffect(() => {
        if(wrapperHeight){
            document.documentElement.style.setProperty("--wrapper-height", wrapperHeight + "px");
        }
    }, [wrapperHeight]); 

    return (
        <MemoryLevelContext.Provider 
        value={{levelList,
                levels, 
                chooseLevel, 
                chooseStage,
                chooseBoth, 
                unsetLevels, 
                memoryCards,
                cardsReady, 
                setCardsReady, 
                setMemoryCards, 
                getCards,  
                cards,
                handleCards, 
                handleShuffleCards, 
                allCardsMatch, 
                memoryCompleted, 
                handleMemoryCompleted, 
                memoryCards,
                setReadyToCheckCards,
                setWrapperHeight,
                noMatch,
                displayTimer,
                setDisplayTimer 
        }}>{props.children}</MemoryLevelContext.Provider>
    );
};

 export default MemoryLevelContextProvider;
